import { render } from "./EllipsisText.vue?vue&type=template&id=05a143cb&scoped=true"
import script from "./EllipsisText.vue?vue&type=script&lang=js"
export * from "./EllipsisText.vue?vue&type=script&lang=js"

import "./EllipsisText.vue?vue&type=style&index=0&id=05a143cb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a143cb"]])

export default __exports__